<template>
  <div>
    <div v-if="error" class="alert alert-danger width-100">
      <strong>Ошибка!</strong>
    </div>
  <table @click.stop class="machine-service-timeline table table-settings-service" :class="{'dragging-container': dragging}">
    <tbody>
    <tr>
      <td>
        <small style="color: #719dc6;">План</small>
      </td>
      <td v-for="day in daysComputed" class="circle-td">
        <div
          class="planned mx-auto mb-2"
          :class="markerClass(service, true)"
          v-for="service in day.planned"
          @dragenter="dragenter($event, service)"
          @dragleave="dragleave($event, service)"
          @drop="leave(service)"
          @click="edit(day, service)"
          @dragover.prevent
        >
          <div v-if="service.circles.tl" class="circle small-circle top-left-circle"></div>
          <div v-if="service.circles.tr" class="circle small-circle top-right-circle" :class="trColor(service.circles.tr)"></div>
          <div v-if="service.circles.bl" class="circle small-circle bottom-left-circle"></div>
          <div v-if="service.circles.br" class="circle small-circle bottom-right-circle"></div>
        </div>
      </td>
    </tr>
    <tr>
      <td></td>
      <td v-for="day in daysComputed" @click="create(day)">
        <div :class="'number-container mx-auto ' + (day.weekday == 0 ? 'sunday' : (day.weekday == 6 ? 'saturday' : ''))">
          <div class="number">{{day.day}}</div>
        </div>
      </td>
    </tr>
    <tr>
      <td>
        <small style="color: #5fa615;">Факт</small>
      </td>
      <td v-for="day in daysComputed">
        <div
          v-for="service in day.performed"
          class="mx-auto mb-2"
          :class="markerClass(service, false)"
          :draggable="!service.planned_service_id"
          @dragstart="drag(service, $event)"
          @dragend="drop(service)"
          @click="showPerformed(service)"
        >
          <div v-if="service.circles.tl" class="circle small-circle top-left-circle"></div>
          <div v-if="service.circles.tr" class="circle small-circle top-right-circle" :class="trColor(service.circles.tr)"></div>
          <div v-if="service.circles.bl" class="circle small-circle bottom-left-circle"></div>
          <div v-if="service.circles.br" class="circle small-circle bottom-right-circle"></div>
          <div class="empty"></div>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
  </div>
</template>

<script>
  import serviceModalPlanned from './service-modal-planned.vue'
  import serviceModalPerformed from './service-modal-performed.vue'
  import moment from 'moment'
  import { each, get } from 'lodash'
  import api from '@/api'

  export default {
    name: 'MachineServiceTimeline',
    props: {
      planned_prop: {
        type: Array,
        required: true,
      },
      performed_prop: {
        type: Array,
        required: true,
      },
      machine_id: {
        required: true,
      },
      operator: {
        required: true,
      },
      tech: {
        required: true,
      },
      region_id: {
        required: true,
      },
      date: {
        default: () => [
          moment().startOf('month').format('YYYY-MM-DD'),
          moment().endOf('month').format('YYYY-MM-DD'),
        ],
      },
    },
    data () {
      return {
        dragging: false,
        selectedService: null,
        draggingOver: null,
        error: false,
        planned: this.planned_prop,
      }
    },
    methods: {
      serviceModalPlanned (day, service, func) {
        this.$root.showModal(serviceModalPlanned, {
          machine_id: this.machine_id,
          date: day.fullDate,
          service: service,
          default_operator: this.operator,
          default_tech: this.tech,
          region_id: this.region_id,
          date_range: this.date,
        }).then((data) => {
          if (data) {
            if (data.deleted) {
              let index = Array.findIndex(this.planned, (current) => current.id === service.id)
              this.planned.splice(index, 1)
            } else {
              func(data.data)
            }
          }
        })
      },
      showPerformed (current) {
        this.$root.showModal(serviceModalPerformed, {
          executor: current.executor,
          id: current.id,
        })
      },
      edit (day, service) {
        this.serviceModalPlanned(day, service, (data) => {
          this.planned = data
        })
      },
      create (day) {
        if (this.$root.canCreateService() && moment().diff(moment(day.fullDate), 'days') <= 0) {
          let serviceParam = {done: false, is_recommended: false}
          this.serviceModalPlanned(day, serviceParam, (data) => {
            this.planned.push(data)
          })
        }
      },
      drag (service, event) {
        if (this.$root.canCreateService()) {
          if (service.planned_service_id === null) {
            event.dataTransfer.setData('text/plain', '')
            this.dragging = true
            this.selectedService = service
          }
        } else {
          event.preventDefault()
        }
      },
      drop (service) {
        if (service.planned_service_id === null) {
          this.dragging = false
          this.selectedService = null
        }
      },
      dragenter ($e, service) {
        this.draggingOver = service.id
      },
      dragleave ($e, service) {
        this.draggingOver = null
      },
      leave (service) {
        if (this.withoutPerformed(service) && this.dragging) {
          let buf = this.selectedService
          api.post('services/bind', {
            planned_service_id: service.id,
            id: buf.id,
          }).then(() => {
            buf.planned_service_id = service.id
            service.done = true
          }).catch((error) => {
            if (error.response) {
              this.error = true
              setTimeout(() => {
                this.error = false
              }, 3000)
            }
          })
        }
      },
      trColor (number) {
        switch (number) {
          case 1: return ''
          case 2: return 'brown'
          case 3: return 'purple'
        }
      },
      withoutPerformed (service) {
        return !service.done && !service.is_recommended && this.selectedService &&
          JSON.stringify(service.circles) === JSON.stringify(this.selectedService.circles) &&
          moment(this.selectedService.date).diff(moment(service.date), 'days', true) >= 0
      },
      markerClass (service, isPlanned) {
        const classes = []
        if (isPlanned && this.withoutPerformed(service)) {
          classes.push('without-performed')
          if (this.draggingOver === service.id) {
            classes.push('drop-target')
          }
        }
        if (service.circles.triangle) {
          if (isPlanned || service.planned_service_id !== null) {
            classes.push('triangle')
          }

          if (isPlanned) {
            classes.push('triangle-planned')
          } else if (service.late) {
            classes.push('triangle-late')
          } else {
            classes.push('triangle-performed')
          }
        } else {
          if (['service', 'service_superior'].includes(get(service, 'executor.role.name'))) {
            classes.push('circle')
          }
          classes.push('circle-container')

          if (isPlanned) {
            classes.push('bg-primary')
          } else if (service.late) {
            classes.push('bg-danger')
          } else {
            classes.push('green')
          }
        }
        if (!isPlanned && service.planned_service_id === null) {
          if (service.circles.triangle) {
            classes.push('triangle-without-planned')
          } else {
            classes.push('without-planned')
          }
        }
        if (service.is_recommended || service.recommendation) {
          classes.push('has-recommendation')
        }
        return classes
      },
    },
    computed: {
      performed () {
        return this.performed_prop
      },
      daysComputed: function () {
        let days = []
        let data = []
        each(this.planned, (date) => {
          let str = date.date
          if (data[str] === undefined) {
            data[str] = {
              performed: [],
              planned: [],
            }
          }
          data[str].planned.push(date)
        })
        each(this.performed, (date) => {
          let str = moment.parseZone(date.date).format('YYYY-MM-DD')
          if (data[str] === undefined) {
            data[str] = {
              performed: [],
              planned: [],
            }
          }
          data[str].performed.push(date)
        })
        const from = moment(this.date[0])
        const to = moment(this.date[1])
        for (let m = from; m.diff(to, 'days') <= 0; m.add(1, 'days')) {
          let planned = []
          let performed = []
          let str = m.format('YYYY-MM-DD')
          if (str in data) {
            planned = data[str].planned
            performed = data[str].performed
          }
          days.push({
            day: m.date(),
            planned: planned,
            performed: performed,
            fullDate: str,
            weekday: m.day(),
          })
        }

        return days
      },
    },
    watch: {
      planned_prop (nv, ov) {
        if (nv !== ov) {
          this.planned = this.planned_prop
        }
      }
    },
  }
</script>

<style lang="scss">
  @import "boot";
  .machine-service-timeline {
    margin: 10px 0;
    .number-container {
      cursor: pointer;
      background-color: #b7bcc0;
      color: #ffffff;
      border-radius: 50%;
      text-align: center;
      width: 1.9em;
      height: 1.9em;
      line-height: 1.9;
    }
    .saturday {
      background-color: #979ca0;
    }
    .sunday {
      background-color: #676c70;
    }
    &,
    & tr,
    & td {
      background: transparent !important;
    }
    & td {
      height: auto !important;
      padding: .2rem !important;
      border-width: 0px !important;
    }
    .circle-td {
      vertical-align: bottom !important;
    }
    .circle-container {
      cursor: pointer;
      position: relative;
      width: 18px !important;
      height: 18px !important;
    }
    .circle {
      border-radius: 50%;
    }
    .small-circle {
      width: 7px;
      height: 7px;
      position: absolute;
    }
    .top-left-circle {
      top: -2px;
      left: -2px;
      background-color: black;
    }
    .top-right-circle {
      top: -2px;
      right: -2px;
      background-color: #5fa615;
    }
    .purple {
      background-color: #bd10e0;
    }
    .brown {
      background-color: #8b572a;
    }
    .green{
      background-color: #90d726;
    }
    .bottom-left-circle {
      bottom: -2px;
      left: -2px;
      background-color: #db392a;
    }
    .bottom-right-circle {
      bottom: -2px;
      right: -2px;
      background-color: #f5a623;
    }
    .triangle {
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-bottom: 18px solid #428bca;
    }
    .triangle-planned {
      border-bottom-color: #428bca;
    }
    .triangle-late {
      border-bottom-color: #bf3030;
    }
    .triangle-performed {
      border-bottom-color: #7db22d;
    }
    .triangle-without-planned {
      position: relative;
      width:0;
      border-bottom:solid 18px #537f2d;
      border-right:solid 10px transparent;
      border-left:solid 10px transparent;
    }
    .triangle-without-planned .empty {
      position: absolute;
      top:7px;
      left:-5px;
      width:0;
      border-bottom:solid 8px;
      border-right:solid 5px transparent;
      border-left:solid 5px transparent;
    }
    .triangle-late .empty {
      border-bottom-color: #bf3030;
    }
    .triangle-performed .empty {
      border-bottom-color: #7db22d;
    }
    .without-planned {
      box-shadow: inset 0 0 0 4px rgba($gray-900, 0.5);
    }
    &.dragging-container {
      .planned:not(.without-performed) {
        opacity: 0.33;
      }
      .without-performed {
        box-shadow: 0 0 0 3px #fff, 0 0 0 6px rgba($primary, 0.5);
        &.drop-target {
          box-shadow: 0 0 0 3px #fff, 0 0 0 10px rgba($primary, 0.5);
        }
      }
    }

    body {
      background: #454a59;
    }

    .has-recommendation {
      position: relative;
      transform: translateZ(0.01px);
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 300%;
        height: 300%;
        box-sizing: border-box;
        margin-left: -100%;
        margin-top: -100%;
        border-radius: 50%;
        background-color: #01a4e9;
        animation: pulse-ring 1.25s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
      }
      &:after {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        display: block;
        width: 100%;
        height: 100%;
        background-color: white;
        border-radius: 50%;
        animation: pulse-dot 1.25s cubic-bezier(0.455, 0.03, 0.515, 0.955) -.4s infinite;
      }
      @keyframes pulse-ring {
        0% {
          transform: scale(.33);
        }
        80%, 100% {
          opacity: 0;
        }
      }
      @keyframes pulse-dot {
        0% {
          transform: scale(.3);
        }
        40% {
          transform: scale(.6);
        }
        100% {
          transform: scale(.3);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/machine-service-timeline.vue